import React from 'react'
import Page from 'src/components/Page';
import { Container,Alert,Stack,Box,Divider,Dialog,DialogTitle,DialogContent,
    TextField,Typography,Card,Autocomplete,Button,DialogActions,Tab,Breadcrumbs,Link} from '@mui/material';
import { LoadingButton,TabPanel,TabContext,TabList } from '@mui/lab';
import { useState,useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import MonthlyEscalationReport from 'src/sections/reports/MonthlyEscalationReport';
import AllClientMonthlyReport from 'src/sections/reports/AllClientMonthlyReport';
import SupervisorQcReport from 'src/sections/reports/SupervisorQcReport';
import MonthlyClientDashBoard from 'src/sections/reports/MonthlyClientDashBoard';
import DailyEmailReports from 'src/sections/reports/DailyEmailReports';
import ClientContacts from 'src/sections/clientContacts/ClientContacts';
import { getCamerasList } from 'src/api/analytics';
import client from 'src/api/clients';
import BarChart from 'src/sections/reports/BarChart';
import BarChartTest from 'src/sections/reports/BarChartTest';
import CameraActiveReport from 'src/sections/reports/CameraActiveReport';
import { alpha } from '@mui/material/styles';
import Credits from 'src/sections/reports/Credits';
import Storage from 'src/sections/reports/Storage';

export default function CreditSettings() {
  const theme = useTheme();
  const [clientList,setClientList]=useState([]) 
  const [cameras, setCameras] = useState([])
  // useEffect(() => {
  //   getClientList((response) => {
  //     if (response.status === 200) {
  //        setClientList(response.data)
  //     }
  //   })
  //   },[])

  useEffect(() => {
    client.getClients((response) => {
      if (response.status === 200) {
        const normalizedClients = (response.data || []).map((item) => ({
          ...item,
          Location: item.hasOwnProperty('Location') ? item.Location : '',
          AssignClient: item.hasOwnProperty('AssignClient') ? item.AssignClient : 0
        }));
        const usClients = normalizedClients.filter((c) => c.ClientType === "US" && c.EnvironmentType !== 0);
        const sortedData = [...usClients].sort((a,b)=>
          a.displayname.trim().localeCompare(b.displayname.trim())
        )
        setClientList(sortedData);
      }
    });

      getCamerasList((response) => {
          if (response.status === 200) {
            setCameras(response.data)
          }
      })
  }, []);
  
    const [value, setValue] = useState('one');
    const handleChange = (event, newValue) => {
        setValue(newValue);
      };

    return (
        <Page title="Reports">
        <Container maxWidth="xxl">
          <Box sx={{ mb: 4 }}>
            <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
              <Typography variant="h4">Credit Settings</Typography>
            </Box>
            <Breadcrumbs separator="•" aria-label="breadcrumb">
              <Link underline="hover" color="inherit" href="/" sx={{ fontSize: '0.875rem' }}>Dashboard</Link>
              <Typography color="text.primary" sx={{ fontSize: '0.875rem' }}>Credit Settings</Typography>
            </Breadcrumbs>
          </Box>
          
          <Card>
            <TabContext value={value}>
              <TabList
                  onChange={handleChange}
                  aria-label="deployment report tabs"
                  sx={{
                    px: 2,
                    bgcolor: 'background.neutral',
                    '& .MuiTab-root': {
                      typography: 'body2',
                      fontWeight: 500,
                      color: 'text.secondary',
                      minHeight: 48,
                      '&.Mui-selected': {
                        color: 'text.primary',
                        fontWeight: 600,
                      },
                    },
                    '& .MuiTabs-indicator': {
                      bgcolor: 'primary.main',
                    },
                  }}
                >
                <Tab 
                  value="one" 
                  label="Add Credits" />
                <Tab
                  value="two"
                  label="Add Additional Amount"
                />                              
                </TabList>

                <TabPanel value="one" index={1} sx={{ p: 0}}>
                  <Credits/>
                </TabPanel>

                <TabPanel value="two" index={0} sx={{ p: 0}}>                
                  <Storage/>
                </TabPanel>
  
               
  
                

                {/* <TabPanel value="four" index={2} sx={{ p: 0}}>
                    <DailyEmailReports
                    // clientList={clientList}
                    />
                </TabPanel> */}

                {/* <TabPanel value="five" index={2} sx={{ p: 0}}>
                    <ClientContacts
                    // clientList={clientList}
                    />
                </TabPanel> */}

                

                {/* <TabPanel value="four" index={2} sx={{ p: 0}}>
                    <SupervisorQcReport
                    />
                </TabPanel>
                <TabPanel value="five" index={2} sx={{ p: 0}}>
                    <BarChartTest
                    />
                </TabPanel> */}
                
            </TabContext>
          </Card>
        </Container>
      </Page>
      );
}
